const setTransitionShownInLocalStorage = () => {
  localStorage.setItem(
    "userSeenRecommendationsTransition",
    JSON.stringify({
      seen: true,
      timestamp: new Date().toISOString(),
    }),
  );
};

const userSawTransitionRecently = () => {
  const userHasSeenTransition = localStorage.getItem(
    "userSeenRecommendationsTransition",
  );

  if (!userHasSeenTransition) {
    return false;
  }

  const whenUserSawTransition = new Date(
    JSON.parse(userHasSeenTransition).timestamp,
  );

  const currentTime = new Date();
  const differenceInMilliseconds = currentTime - whenUserSawTransition;
  const differenceInMinutes = differenceInMilliseconds / 60000;

  return differenceInMinutes < 60;
};

const transitionElement = document.querySelector(
  ".js-recommendations-transition",
);

const showTransitionToUser = () => {
  if (transitionElement) {
    transitionElement.classList.add("show-recommendations-transition");
  }
};

if (userSawTransitionRecently()) {
  // if we don't remove the element then it will still show on the page, just without the transition
  transitionElement.remove();
} else {
  showTransitionToUser();
  setTransitionShownInLocalStorage();
}
